import { t } from "@lingui/core/macro";
import type { GuiTimeZone } from "@mm/metx-workbench.meteomatics.com";

export const timezones: Record<GuiTimeZone, () => string> = {
  local: () => t`Local`,
  utc: () => t`UTC`,
};
